<div class="flx-table-card h-full flex flex-col">
  <div class="flx-card-header flex flex-row items-center justify-between gap-4 grow-0">
    <h3 class="text-2xl font-semibold capitalize">Failed Process Start</h3>
    <span></span>
    <form
      [formGroup]="exceptionsFilterFG"
      class="grid grid-cols-3 items-center w-1/2 gap-4"
    >
      <flx-select
        [hasClear]="true"
        [hasSearch]="true"
        (filterChange)="processFilter$.next($event)"
        class="flx-ds"
        formControlName="definitionName"
        placeholder="Filter by process definition"
      >
        @for (process of filteredApplicationProcesses(); track process.id) {
          <flx-select-option [value]="process">
            {{ process.resourceName }}
          </flx-select-option>
        }
      </flx-select>
      <div
        [formGroup]="dateRangeGroupFG"
        class="col-span-2 flex items-center gap-2"
      >
        <p-datepicker
          [defaultDate]="startTime"
          [showTime]="true"
          [showIcon]="true"
          [showClear]="true"
          class="flx-ds"
          dateFormat="dd M yy, "
          iconDisplay="input"
          formControlName="startDate"
          placeholder="From date"
        ></p-datepicker>
        <span> - </span>
        <p-datepicker
          [defaultDate]="endTime"
          [showTime]="true"
          [showIcon]="true"
          [showClear]="true"
          class="flx-ds"
          dateFormat="dd M yy, "
          iconDisplay="input"
          formControlName="endDate"
          placeholder="To date"
        ></p-datepicker>
      </div>
    </form>
  </div>
  <div class="versioned-table-wrapper h-full">
    <flx-resources-grid
      [tableDef]="exceptionsTableColumns"
      [inputGridOptions]="gridOptions()"
      [rowClickEnabled]="true"
      (gridReady)="onGridReady($event)"
      (rowClick)="navigateToException($event)"
      emptyMsg="No exceptions found."
    ></flx-resources-grid>
  </div>
</div>
